export const PAYPAL_FAILURE_PATH = "/:channel/paypal-failure";
export const PAYPAL_SUCCESS_PATH = "/:channel/paypal-authorized";
